module.exports = "/images/fizmix-teacher-logo.svg?fee00943c06cd5590946e0592edfff60";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/fizmix-teacher-logo.svg
// module id = Tfdd
// module chunks = 0